import AddLocationAlt from '@mui/icons-material/AddLocationAlt'
import {Box, Button, Container, Divider, Stack} from '@mui/material'
import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router'
import {useBrowserTitle} from '../../hooks/useDom'
import {getLangUrl} from '../../hooks/useSpotNavigate'
import logo from '../../resources/logo.svg'
import {SpotLastList} from './components/SpotLastList'
import {SpotSelector} from './components/SpotSelector'

export const Landing = memo(() => {
  const {t} = useTranslation()
  useBrowserTitle(undefined)

  return <Container sx={{my: 4}} maxWidth={false}>
    <Stack direction="column" sx={{gap: 6, alignItems: 'center'}}>
      <SpotLastList
        fallback={<img style={{width: '100%', maxWidth: 256, opacity: 0.9}} src={logo} alt="VerticalTopo logo"/>}
      />

      <Container disableGutters maxWidth="xs">
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <SpotSelector/>

          <Divider sx={{my: 4}} flexItem>{t('page.landing.alternate')}</Divider>

          <Button component={Link} to={getLangUrl('/spot-create')} variant="contained" startIcon={<AddLocationAlt/>}>
            {t('page.landing.button.create')}
          </Button>
        </Box>
      </Container>
    </Stack>
  </Container>
})
